import type { AnalyticsConfig } from './analyticsConfig';

export async function downloadAnalyticsPng(container: HTMLElement | null, fileName: string) {
  if (!container) return;

  const downloadButton = container.querySelector<HTMLElement>('.gda-analytics-header__download');
  const previousDisplay = downloadButton?.style.display ?? '';

  if (downloadButton) {
    downloadButton.style.display = 'none';
  }

  const width = container.offsetWidth;
  const height = container.scrollHeight;

  try {
    const { toPng } = await import('html-to-image');
    const dataUrl = await toPng(container, {
      backgroundColor: '#ffffff',
      cacheBust: true,
      pixelRatio: 2,
      width,
      height,
      skipFonts: true,
    });

    const link = document.createElement('a');
    link.download = fileName;
    link.href = dataUrl;
    link.click();
  } finally {
    if (downloadButton) {
      downloadButton.style.display = previousDisplay;
    }
  }
}

export function buildAnalyticsFileStem(config: AnalyticsConfig, entityName: string): string {
  const safeName = String(entityName ?? 'search')
    .replace(/[^\w.-]+/g, '_')
    .slice(0, 60);
  return `${config.tab.toLowerCase()}-analytics-${safeName}`;
}
